import classNames from 'classnames';
import styled from 'styled-components';

import { Illness as IllnessType } from '../types';
import { Interval } from 'components/types';

import { brightness } from 'utils/misc';

import Absence from './Absence';

const StyledIllnessAbsence = styled(Absence)`
  &.is-external-absence {
    background-size: 25px 25px !important;

    &.has-overlap {
      .employee-name {
        visibility: hidden;
      }
    }
  }
`;

type Props = {
  absence: IllnessType;
  interval: Interval;
  className?: string | undefined;
};

export default function Illness({ absence, interval, className }: Props) {
  const { isExternal, hasOverlap, dutyHourType } = absence;
  const { colorCode: dhtColor = '#ff0033' } = dutyHourType;

  let background = 'white';

  if (isExternal) {
    const stripeColor = brightness(dhtColor as `#${string}`, 85);
    background = `
            linear-gradient(
                -45deg,
                ${stripeColor} 25%,
                #ffffff 25%,
                #ffffff 50%,
                ${stripeColor} 50%,
                ${stripeColor} 75%,
                #ffffff 75%,
                #ffffff 100%
            )
        `;
  }

  return (
    <StyledIllnessAbsence
      absence={absence}
      className={classNames(
        'absence',
        'illness',
        {
          'is-external-absence': isExternal,
          'has-overlap': hasOverlap
        },
        className
      )}
      borderColor={dhtColor}
      background={background}
      interval={interval}
    />
  );
}
